module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"281d6bbc55953824b189396d16e93651"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
